import {api} from "../api";

export function carFilter() {
    return {
        makeId: null,
        modelId: null,
        motoId: null,
        year: null,
        response: null,
        years: [],
        models: [],
        types: [],
        int() {
            for (let i = 2022; i >= 1966; i--) {
                this.years.push(i)
            }
        },
        async getModel() {
            this.modelId = null;
            this.motoId = null;
            this.$refs.model.innerText = 'Loading ...'
            this.response = await api.post('extension/module/carfilter/models', `makeId=${this.makeId}`);
            this.$refs.model.innerText = this.response.text_select;
            this.models = this.response.response;
        },
        async getMotorizari() {
            this.motoId = null;
            this.$refs.tip.innerText = 'Loading ...'
            this.response = await api.post('extension/module/carfilter/types', `makeId=${this.makeId}&modelId=${this.modelId}`)
            this.$refs.tip.innerText = this.response.text_select;
            this.types = this.response.response
        },
        async jumpToCar() {
            const make = this.getSelectedValueForId('marca');
            const model = this.getSelectedValueForId('model');
            const tip = this.getSelectedValueForId('tip');

            this.response = await api.post('extension/module/carfilter/jump', `tipId=${this.motoId}&make=${make}&model=${model}&tip=${tip}`)
            if (this.response.href) {
                window.location.href = this.response.href
            }
        },
        getSelectedValueForId(elementId) {
            const makeSelect = document.getElementById(elementId)
            return makeSelect.options[makeSelect.selectedIndex].text;
        }
    }
}